 
import * as constants from './constants';
import userRequest, {
    userApi
} from 'common/request';
const changeLiveInfo = (liveinfo) => ({
    type: constants.CHANGE_LIVE_INFO,
    liveinfo 
});
 
export const getMemberList = (memberlist)=>({
  type:constants.GET_MEMBERLIST,
  memberlist, 
})

export const addMemberList = (memberlist)=>({
  type:constants.ADD_MEMBERLIST,
  memberlist
})

export const removeMemberList = (memberlist)=>({
  type:constants.REMOVE_MEMBERLIST,
  memberlist
})
const changeChatList = (chatList)=>({
   type: constants.CHANGE_CHAT_LISTS,
   chatList
})
 
//获取直播详情
export const getLiveInfo = (course_id,user_id,username) => {
    return (dispatch) => {
         userRequest.get(window.AppConfig.liveIP+userApi.getLiveInfo,{
                course_id,
                user_id:user_id||'',
                username:username||''
            }).then((res) => {
                /*if(res.code===0){
                    dispatch(changeLiveInfo(res.data))
                } */
                dispatch(changeLiveInfo(res.data))
        });
    }
}
//发送数据
 export const  sendMessage = (roomid,body, param)=>{
  return (dispatch) =>{
    userRequest.postRequest(`${window.AppConfig.websocketHTTP}/push/room`, body, {
      params: {
        room: roomid,
        type: 'live',
        operation: parseInt(roomid),
        ...(param || {}),
      },
      headers: {
          // 'Accept': 'application/json, text/plain, */*',
          // 'Content-Type': 'application/json',

      },
    }).then((res) => {
        console.log('http发送返回:',res);
      })
  }
}
 
 
// //获取成员列表
//  export const  getMemberList = (id)=>{
//   return (dispatch)=>{
//      userRequest.get(window.AppConfig.liveIP+userApi.getMemberList,{
//                 id
//             }).then((res) => {
//               console.log(res)
//                 if(res.code===0){
                    
//                 } 
//         });
//   }
//  }
//  //添加成员列表
//   export const  addMemberList = (id)=>{
//   return (dispatch)=>{
//      userRequest.get(window.AppConfig.liveIP+userApi.addMemberList,{
//                 id
//             }).then((res) => {
//               console.log(res)
//                 if(res.code===0){
                    
//                 } 
//         });
//   }
//  }
// //删除成员列表
//  export const  removeMemberList = (id)=>{
//   return (dispatch)=>{
//      userRequest.get(window.AppConfig.liveIP+userApi.getLiveInfo,{
//                 id
//             }).then((res) => {
//               console.log(res)
//                 if(res.code===0){
                    
//                 } 
//         });
//     }
//  }
 // /person/live-api/add-topic
 export const  addChat = (content,user_id,course_id,user_name,user_tenant)=>{
  return (dispatch) =>{
    userRequest.post(window.AppConfig.topicchat+userApi.addchat,{ 
              content,
              user_id,
              course_id,
              user_name,
              user_tenant:window.AppConfig.userTenant
            }).then((res) => {
              if(res.code===0){
                console.log('addChat:',res);
              }else{
                 console.log('添加失败')
              }
        
      })
  }
}

export const  getChat = (course_id)=>{
  return (dispatch) =>{
    userRequest.get(window.AppConfig.topicchat+userApi.getchat,{ 
              course_id,
              user_tenant:window.AppConfig.userTenant
            }).then((res) => {
              if(res.code===0){
                
                dispatch(changeChatList(res.data.lists))
              }else{
               
                console.log('获取失败')
              }
       
      })
  }
}

export const getUserInfo = () => {
   return (dispatch) => {
     let userinfo =JSON.parse(localStorage.getItem("userinfo")||"{}");
     return userinfo 
   }
}
export const getUserValue=(name) =>{
  return (dispatch) => {    
       let userinfo =JSON.parse(localStorage.getItem("userinfo")||"{}");
       if ( userinfo.hasOwnProperty(name)) {
            return userinfo[name]
          }else{
            return '游客'+Math.round(Math.random());
        }

      
   }
   
}